module.exports = __webpack_public_path__ + "img/nfc_reader.535e411c.png";